var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProhibited(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ff0000",
    height: "800px",
    width: "800px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 512 512",
    stroke: "#ff0000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M412.719,54.022C369.356,20.299,315.059,0,256,0C114.844,0,0,114.844,0,256c0,59.058,20.299,113.353,54.021,156.715 L412.719,54.022z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.97,99.271L99.268,457.967C142.633,491.696,196.936,512,256,512c141.156,0,256-114.844,256-256 C512,196.936,491.698,142.636,457.97,99.271z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProhibited);
export default __webpack_public_path__ + "static/media/prohibited.a3bb8528da7261a70ff52fbc6eabdfa4.svg";
export { ForwardRef as ReactComponent };